import { z } from 'zod'

/** Validates UUID identity and returns its canonical lowercase representation. */
export const UuidSchema = z.uuid().transform((id) => id.toLowerCase())
